import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import KsDlDetail from './KsDLCoADetail';

class KsDLCoAModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  sendNavigationRequest() {
    return null;
  }

  render() {
    const { show, } = this.state;
    const { submission, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              License Id&nbsp;
              {submission.id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <KsDlDetail submission={submission} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

KsDLCoAModal.propTypes = {
  submission: PropTypes.instanceOf(Object).isRequired,
};

export default KsDLCoAModal;
